'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-b2d9610a.js');
var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
var Icons = require('./Icons-46f5553f.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".Breadcrumbs_module_visuallyHidden__7954ea50 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Breadcrumbs_module_youtubeVideo__7954ea50 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Breadcrumbs_module_Breadcrumbs__7954ea50 {\n  width: 100%;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol {\n  width: 100%;\n  display: block;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  white-space: nowrap;\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n@media only screen and (min-width: 768px) {\n  .Breadcrumbs_module_Breadcrumbs__7954ea50 ol {\n    text-align: left;\n  }\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol::-webkit-scrollbar {\n  display: none;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 {\n  display: inline-flex;\n  vertical-align: middle;\n  align-items: center;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50:first-child .Breadcrumbs_module_BreadcrumbItemLinkDivider__7954ea50 {\n  display: none;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50:last-child a, .Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50:last-child button {\n  font-weight: 700;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 .Breadcrumbs_module_BreadcrumbItemLink__7954ea50 {\n  height: auto;\n  display: inline-flex;\n  position: relative;\n  padding: 14px;\n  border-radius: 48px;\n  border: 2px;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  line-height: 100%;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 .Breadcrumbs_module_BreadcrumbItemLink__7954ea50 > span {\n  height: auto;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0;\n  color: #444F6B;\n  font-family: var(--font-family-1, \"Karla\", sans-serif);\n  font-size: 14px;\n  line-height: 16px;\n  text-align: center;\n  border: 0;\n  border-radius: 48px;\n  cursor: pointer;\n  box-shadow: none;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 .Breadcrumbs_module_BreadcrumbItemLink__7954ea50 > span svg {\n  margin-right: 12px;\n  fill: #444F6B;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 .Breadcrumbs_module_BreadcrumbItemLink__7954ea50 .Breadcrumbs_module_Label__7954ea50 {\n  max-width: 175px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 .Breadcrumbs_module_BreadcrumbItemLink__7954ea50:hover {\n  text-decoration: underline;\n  color: #444F6B;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50 .Breadcrumbs_module_BreadcrumbItemLink__7954ea50:focus-visible {\n  box-shadow: inset 0 0 0px 3px #7f5f9c;\n  color: #444F6B;\n  background-color: white;\n}\n.Breadcrumbs_module_Breadcrumbs__7954ea50 ol li.Breadcrumbs_module_BreadcrumbItem__7954ea50.Breadcrumbs_module_BreadcrumbItemUppercase__7954ea50 {\n  text-transform: uppercase;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Organisms/Breadcrumbs/Breadcrumbs.module.scss");
var modules_a04642f2 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Breadcrumbs_module_visuallyHidden__7954ea50","youtubeVideo":"Breadcrumbs_module_youtubeVideo__7954ea50","Breadcrumbs":"Breadcrumbs_module_Breadcrumbs__7954ea50","BreadcrumbItem":"Breadcrumbs_module_BreadcrumbItem__7954ea50","BreadcrumbItemLinkDivider":"Breadcrumbs_module_BreadcrumbItemLinkDivider__7954ea50","BreadcrumbItemLink":"Breadcrumbs_module_BreadcrumbItemLink__7954ea50","Label":"Breadcrumbs_module_Label__7954ea50","BreadcrumbItemUppercase":"Breadcrumbs_module_BreadcrumbItemUppercase__7954ea50"};

function Breadcrumbs(_ref) {
  _ref.ariaLabel;
    var breadcrumbsItems = _ref.breadcrumbsItems,
    extraClass = _ref.extraClass,
    backgroundColor = _ref.backgroundColor,
    _ref$microdata = _ref.microdata,
    microdata = _ref$microdata === void 0 ? true : _ref$microdata;
  return /*#__PURE__*/React__default["default"].createElement("nav", {
    "aria-label": "Breadcrumb",
    className: [modules_a04642f2.Breadcrumbs, extraClass].join(" "),
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React__default["default"].createElement("ol", _rollupPluginBabelHelpers._extends({
    id: "breadcrumblist",
    className: modules_a04642f2.BreadcrumbContent
  }, microdata && {
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList"
  }), breadcrumbsItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", _rollupPluginBabelHelpers._extends({
      key: index,
      className: [modules_a04642f2.BreadcrumbItem, item.uppercase ? modules_a04642f2.BreadcrumbItemUppercase : null].join(" ")
    }, microdata && {
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "https://schema.org/ListItem"
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_a04642f2.BreadcrumbItemLinkDivider,
      "aria-hidden": "true"
    }, "/"), item.isButton ? /*#__PURE__*/React__default["default"].createElement("button", _rollupPluginBabelHelpers._extends({
      className: modules_a04642f2.BreadcrumbItemLink,
      "aria-label": item.ariaLabel,
      "aria-current": item.isActive ? "page" : null,
      "aria-hasPopUp": item.hasPopUp ? "true" : null,
      onClick: item.onClick,
      title: item.label,
      "typeof": item.typeOf || "WebPage"
    }, microdata && {
      itemProp: "item"
    }), item.iconDefault ? /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_a04642f2.Icon
    }, /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
      iconWSize: 18,
      iconHSize: 18,
      iconName: item.iconDefault
    })) : null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_a04642f2.Label,
      itemProp: "name"
    }, item.label)) : /*#__PURE__*/React__default["default"].createElement("a", _rollupPluginBabelHelpers._extends({
      key: index,
      href: item.href,
      className: modules_a04642f2.BreadcrumbItemLink,
      "aria-current": item.isActive ? "page" : null,
      title: item.label,
      onClick: item.onClick
    }, microdata && {
      itemProp: "item"
    }, {
      "typeof": item.typeOf || "WebPage"
    }), item.iconDefault ? /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_a04642f2.Icon
    }, /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
      iconWSize: 18,
      iconHSize: 18,
      iconName: item.iconDefault
    })) : null, /*#__PURE__*/React__default["default"].createElement("span", _rollupPluginBabelHelpers._extends({
      className: modules_a04642f2.Label
    }, microdata && {
      itemProp: "name"
    }), item.label)), microdata && /*#__PURE__*/React__default["default"].createElement("meta", {
      itemProp: "position",
      content: index + 1
    }));
  })));
}
Breadcrumbs.propTypes = {
  breadcrumbsItems: index.propTypes.exports.arrayOf(index.propTypes.exports.shape({
    label: index.propTypes.exports.string,
    href: index.propTypes.exports.string,
    isButton: index.propTypes.exports.bool,
    onClick: index.propTypes.exports.func,
    isActive: index.propTypes.exports.bool,
    maxWidth: index.propTypes.exports.string,
    uppercase: index.propTypes.exports.bool,
    //WCAG
    ariaLabel: index.propTypes.exports.string,
    hasPopUp: index.propTypes.exports.bool,
    //Icon
    iconDefault: index.propTypes.exports.string,
    typeOf: index.propTypes.exports.string
  })),
  extraClass: index.propTypes.exports.string,
  backgroundColor: index.propTypes.exports.string,
  microdata: index.propTypes.exports.bool
};

exports.Breadcrumbs = Breadcrumbs;
